import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1.2rem;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
`;

export const ServiceName = styled.div`
  font-size: 1.2rem;
  font-style: italic;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.6rem;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.4rem;
  gap: 1rem;
`;

export const Name = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const Date = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  white-space: nowrap;
`;

export const Stars = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.amber};
  letter-spacing: 0.2rem;
  margin-bottom: 0.4rem;
`;

export const Comment = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
`;
